export default __webpack_public_path__ + "static/media/My-Img-7.44b2c912.jpg";